import React, { useContext, useMemo } from 'react';

// DEPENDENCIES
import keyBy from 'lodash/keyBy';
import orderBy from 'lodash/orderBy';
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { SALES_FILE_TYPE_IDS } from 'globals.js';

// FUNCTIONS/HELPERS
import { RecordContext } from 'helpers/getRecordData';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import Card from '../parts/Card';
import Attachment from 'routers/interface/tools/attachment/Attachment';

// MAIN COMPONENT
const ProductsSoldExecutedAgreementsForm = () => {
  const { refetchRecord } = useContext(RecordContext);

  const {
    values: {
      aryDealerAMFinance = [],
      inventory: { new_used } = {}
    }
  } = useFormikContext() || {};

  const uploads = useMemo(() => {
    const ordered = orderBy(
      aryDealerAMFinance || [],
      ['product_type', 'product_code', 'item_name'],
      ['asc', 'asc', 'asc']
    );
    return ordered
      .filter(a => a.product_type === 0 && a.is_checked)
      .map(a => ({
        item_name: a.item_name,
        dealer_amfinance_id: a.dealer_amfinance_id,
        is_checked: a.is_checked
      }));
  }, [aryDealerAMFinance]);

  const documentType = {
    0: SALES_FILE_TYPE_IDS.AMFI_PRODUCT_RETAIL_USED,
    1: SALES_FILE_TYPE_IDS.AMFI_PRODUCT_RETAIL_NEW
  };

  return (
    <Form.Body>
      {uploads.map(a => {
        return (
          <Attachment.Upload
            key={a.dealer_amfinance_id}
            label={`${a.item_name} - Executed Agreement`}
            name={`documentAttachment[${a.dealer_amfinance_id}]`}
            documentType={documentType[new_used]}
            uploadType="sales"
            uploadParams={{
              dealerAMFinanceId: a.dealer_amfinance_id
            }}
            onComplete={refetchRecord}
            multiple={false}
            useDocUpr={false}
          />
        );
      })}
    </Form.Body>
  );
};

// EXPORT
export default function ProductsSoldExecutedAgreements({ number, ...props }) {
  const { record: initialValues = {} } = useContext(RecordContext) || {};

  // Use common unique ID to match document with product when rendering upload field
  const byProductKey = useMemo(
    () => keyBy(initialValues?.documentAttachment?.amfi_product, 'dealer_amfinance_id'),
    [initialValues.documentAttachment]
  );

  return (
    <Card
      number={number}
      title="F&I Products Sold Executed Agreement"
      color="yellow"
      body={
        <Form
          initialValues={{
            ...initialValues,
            documentAttachment: byProductKey
          }}
        >
          <ProductsSoldExecutedAgreementsForm {...props} />
        </Form>
      }
    />
  );
}
